import React from 'react'
import FooterMe from '../components/Footer/FooterMe';
import Navbar from '../components/Navbar/Navbar';
import WorkMe from '../components/Work/WorkMe';
import 'flowbite';

const Work = () => {
  return (
    <>
    <Navbar />
    <WorkMe />
    <FooterMe/>
    </>
  )
}

export default Work